export const getFormattedAnswers = (answerChoices = []) =>
  answerChoices.map(choice => ({
    answerValue: choice.answerValue,
    answerText: choice.answerText,
    hasTextField: choice.textField || false,
    id: choice.id,
  }))
